module.exports = __webpack_public_path__ + "static/media/Service.3fe2bace.svg";